module.exports = __webpack_public_path__ + "static/img/recall-rule.7476b25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/springFestivalActive/recall/recall-rule.png
// module id = xWO/
// module chunks = 1